import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/user' + path, queryMap);
  }

  getCaptcha() {
    const url = this.buildurl('/login/captcha');
    return this.http.get(url);
  }

  verifyCaptcha(x: number) {
    const url = this.buildurl('/login/captcha');
    const body = { x };
    return this.http.put(url, body);
  }

  sendLoginCode(phone: string) {
    const url = this.buildurl('/login/code');
    const body = { phone };
    return this.http.post(url, body);
  }

  loginByPhone(phone: string, code: string, qhclickid: string = '') {
    const url = this.buildurl('/login');
    const body = {
      phone,
      code,
      qhclickid,
    };
    return this.http.put(url, body);
  }

  loginByPassword(phone: string, password: string, qhclickid: string = '') {
    const url = this.buildurl('/login2');
    const body = {
      phone,
      password,
      qhclickid,
    };
    return this.http.put(url, body);
  }

  sendLoginCodeEmail(email: string) {
    const url = this.buildurl('/email/login/code');
    const body = { email };
    return this.http.post(url, body);
  }

  loginByEmail(email: string, code: string, qhclickid: string = '') {
    const url = this.buildurl('/email/login');
    const body = {
      email,
      code,
      qhclickid,
    };
    return this.http.put(url, body);
  }

  loginByEmailPassword(
    email: string,
    password: string,
    qhclickid: string = '',
  ) {
    const url = this.buildurl('/email/login2');
    const body = {
      email,
      password,
      qhclickid,
    };
    return this.http.put(url, body);
  }

  getSelf() {
    const url = this.buildurl('/self');
    return this.http.fget(url);
  }

  logout() {
    const url = this.buildurl('/logout');
    return this.http.put(url, {});
  }

  updateSelfNickname(nickname: string) {
    const url = this.buildurl('/self/nickname');
    const body = { nickname };
    return this.http.put(url, body);
  }

  updateSelfPassword(password: string) {
    const url = this.buildurl('/self/password');
    const body = { password };
    return this.http.put(url, body);
  }

  updateSelfGender(gender: string) {
    const url = this.buildurl('/self/gender');
    const body = { gender };
    return this.http.put(url, body);
  }

  updateSelfAvatar(avatar: string) {
    const url = this.buildurl('/self/avatar');
    const body = { avatar };
    return this.http.put(url, body);
  }

  sendUpdatePhoneCode(phone: string) {
    const url = this.buildurl('/self/phone/code');
    const body = { phone };
    return this.http.post(url, body);
  }

  updateSelfPhone(phone: string, code: string) {
    const url = this.buildurl('/self/phone');
    const body = { phone, code };
    return this.http.put(url, body);
  }

  getTemporayQRCode() {
    const url = this.buildurl('/login/wxqrcode');
    return this.http.fget(url);
  }

  checkTemporayQRCode(id: string) {
    const url = this.buildurl(`/login/wxqrcode/${id}`);
    return this.http.fget(url);
  }

  getUserUnreadNotificationCount() {
    const url = this.buildurl('/notification/unread');
    return this.http.fget(url);
  }

  findUserNotifications(page: number, pageSize: number) {
    const url = this.buildurl('/notifications', { page, page_size: pageSize });
    return this.http.fget(url);
  }

  readAllUserNotification() {
    const url = this.buildurl('/notifications/read');
    return this.http.put(url, {});
  }

  getUserAffiliate() {
    const url = this.buildurl('/affiliate');
    return this.http.fget(url);
  }

  findUserAffiliateUserOrder(
    platformID: number,
    page: number,
    pageSize: number,
  ) {
    const q = {
      platform_id: platformID,
      page,
      page_size: pageSize,
    };
    const url = this.buildurl('/affiliate/user/orders', q);
    return this.http.fget(url);
  }

  findUserAffiliateUserOrderStats() {
    const url = this.buildurl('/affiliate/user/order/stats');
    return this.http.fget(url);
  }

  findUserAffiliateUserOrder14days() {
    const url = this.buildurl('/affiliate/user/order/14days');
    return this.http.fget(url);
  }

  findUserAffiliateWithdrawals(page: number, pageSize: number) {
    const url = this.buildurl('/affiliate/withdrawals', {
      page,
      page_size: pageSize,
    });
    return this.http.fget(url);
  }

  createUserAffiliateWithdrawal(amount: number) {
    const url = this.buildurl('/affiliate/withdrawal');
    const body = { amount };
    return this.http.post(url, body);
  }

  createUserAffiliateWithdrawalAlipay(
    loginID: string,
    name: string,
    amount: number,
  ) {
    const url = this.buildurl('/affiliate/withdrawal/alipay');
    const body = { amount, login_id: loginID, name };
    return this.http.post(url, body);
  }

  findUserAffiliateRatios() {
    const url = this.buildurl('/affiliate/ratios');
    return this.http.fget(url);
  }

  findUserAffiliateUsers(page: number, pageSize: number) {
    const q = {
      page,
      page_size: pageSize,
    };
    const url = this.buildurl('/affiliate/users', q);
    return this.http.fget(url);
  }

  findUserAffiliateCommissionChangelogs(page: number, pageSize: number) {
    const q = {
      page,
      page_size: pageSize,
    };
    const url = this.buildurl('/affiliate/commission/changelogs', q);
    return this.http.fget(url);
  }

  checkAffiliateCode(code: string) {
    const url = this.buildurl(`/affiliate/code/${code}`);
    return this.http.fget(url);
  }

  findRechargePlatforms() {
    const url = this.buildurl('/platformInfo');
    return this.http.fget(url);
  }

  getBus(id: any) {
    const url = this.buildurl(`/platform/${id}`);
    return this.http.fget(url);
  }

  postForm(
    platformID: number,
    busID: number,
    appellation: string,
    contactTime: string,
    purchaseVerify: string,
    customerContact: string,
    email: string,
    password: string,
  ) {
    const url = this.buildurl('/user/git/from');
    const body = {
      platform_id: platformID,
      bus_id: busID,
      appellation,
      contact_time: contactTime,
      purchase_verify: purchaseVerify,
      customer_contact: customerContact,
      email,
      password,
    };
    return this.http.post(url, body);
  }

  createCoupon(code: string) {
    const url = this.buildurl('/users/create/discount/codes');
    const body = { code };
    return this.http.post(url, body);
  }

  findAffiliateCode() {
    const url = this.buildurl('/users/get/codes');
    return this.http.fget(url);
  }

  changeAffiliateModal() {
    const url = this.buildurl('/affiliate/marked');
    return this.http.fget(url);
  }

  getFleetAuthTokens() {
    const url = this.buildurl('/auth/generate_tokens');
    return this.http.fget(url);
  }

  getFleetGrokAuthTokens() {
    const url = this.buildurl('/grok/token');
    return this.http.fget(url);
  }

  postAuthLogin(user_token: string, expire_time: string, partner_id: number) {
    const body = { user_token, expire_time, partner_id };
    const url = this.buildurl('/auth/login/success');
    return this.http.post(url, body);
  }

  getChatgptCount(status: string, car: string) {
    const url = this.buildurl('/chatgpt/count', { status, car });
    return this.http.fget(url);
  }

  getMjCount(status: string, car: string) {
    const url = this.buildurl('/mj/count', { status, car });
    return this.http.fget(url);
  }

  getGrokCount(status: string, car: string) {
    const url = this.buildurl('/grok/db', { status, car });
    return this.http.fget(url);
  }

  findAnnouncements() {
    const url = this.buildurl('/notice/latest');
    return this.http.fget(url);
  }

  checkAnnouncementStatus() {
    const url = this.buildurl('/system/announcement/status');
    return this.http.fget(url);
  }

  getAnnouncement() {
    const url = this.buildurl('/system/announcement');
    return this.http.fget(url);
  }

  confirmDialog(is_computer: boolean) {
    const body = { is_computer };
    const url = this.buildurl('/notice/user/iscomputer');
    return this.http.put(url, body);
  }
  // 获取用户套餐数据;
  getMjUsage(months: any) {
    const body = { months };
    const url = this.buildurl('/open/drawing/usage');
    return this.http.post(url, body);
  }
  //提交绘画任务
  getMjDrawing(rd: any, prompt: string, iw: '1.5', mode: any) {
    const body = { rd, prompt, iw, mode };
    const url = this.buildurl('/mj/drawing/imagine');
    return this.http.post(url, body);
  }
  //查询绘画任务详情
  getMjDrawingDetails(task_no: any) {
    const body = { task_no };
    const url = this.buildurl('/mj/open/drawing/task', body);
    return this.http.fget(url);
  }
  // 查询绘画任务列表
  getMjDrawingList(
    task_no: any,
    page: number,
    page_size: number,
    start_time: any,
    end_time: any,
    confirm: any,
  ) {
    const body = { task_no, page, page_size, start_time, end_time, confirm };
    const url = this.buildurl('/mj/open/drawing/list-task', body);
    return this.http.fget(url);
  }

  getOfficialUserRemain(access: any, current: any, Authorization: any) {
    const head = { access, current, Authorization };
    const options = { headers: head };
    const url = this.buildurl('/gpt/user/remain');
    return this.http.fget(url, options);
  }

  loginFleet(
    car: any,
    currentLogin: string,
    duration: string,
    sign: string,
    times: string,
    access: any,
    current: any,
    Authorization: any,
  ) {
    const head = { access, current, Authorization };
    const options = { headers: head };
    const body = { car, current: currentLogin, duration, sign, times };
    const url = this.buildurl('/gpt/user/login');
    return this.http.post(url, body, options);
  }

  findFleetCards(
    access: any,
    current: any,
    Authorization: any,
    node_id: number,
    page: number,
    page_size: number,
  ) {
    const head = { access, current, Authorization };
    const options = { headers: head };
    const q = {
      node_id,
      page,
      page_size,
    };
    const url = this.buildurl('/gpt/user/list', q);
    return this.http.fget(url, options);
  }

  findFleetCardsGrok(page: number, size: number) {
    const q = { page, size };
    const url = this.buildurl('/grok/carlist', q);
    return this.http.fget(url);
  }

  queryMjModel() {
    const url = this.buildurl('/mj/user/count');
    return this.http.fget(url);
  }

  putMjModel(id: any) {
    const url = this.buildurl(`/mj/user/model/${id}`);
    return this.http.put(url, {});
  }

  findWorkorderRemarks(platform_name: string, la: string) {
    const q = { platform_name, la };
    const url = this.buildurl('/get/platformremark/', q);
    return this.http.fget(url);
  }

  solveWorkProblem(bus_seat_id: number, is_solve: number) {
    const url = this.buildurl('/update/seat/is_solve');
    const body = { bus_seat_id, is_solve };
    return this.http.put(url, body);
  }

  getWorkProbem(bus_seat_id: number) {
    const q = { bus_seat_id };
    const url = this.buildurl('/get/seat/workorder', q);
    return this.http.fget(url);
  }

  createWorkPrblemdetail(
    bus_id: number,
    bus_seat_id: number,
    platform_id: number,
    bus_account_id: number,
    order_id: string,
    work_problem_re: number,
    customer_url: string,
    customer: string,
  ) {
    const body = {
      bus_id,
      bus_seat_id,
      platform_id,
      bus_account_id,
      order_id,
      work_problem_re,
      customer_url,
      customer,
    };
    const url = this.buildurl('/seat/workorder');
    return this.http.post(url, body);
  }

  findWorkProblems(
    platform_name: string,
    status: string,
    la: string,
    page: number,
    page_size: number,
  ) {
    const q = { platform_name, status, la, page, page_size };
    const url = this.buildurl('/get/work/problems', q);
    return this.http.fget(url);
  }

  postQiniu(upload: any) {
    const url = this.buildurl('/qiniu');
    const body = new FormData();
    body.append('upload', upload);
    return this.http.post(url, body);
  }

  getWXAuthConnect() {
    const url = this.buildurl('/wxqrcode');
    return this.http.fget(url);
  }

  getWXAuthConnectStatus() {
    const url = this.buildurl('/wxqrcode/status');
    return this.http.fget(url);
  }

  wechatNoticeModalClose(wechat_notice: boolean) {
    const body = { wechat_notice };
    const url = this.buildurl('/self/wechat/notice');
    return this.http.put(url, body);
  }

  //爆米花首单
  getPopcornStatus() {
    const url = this.buildurl('/bmhstatus');
    return this.http.fget(url);
  }

  // YouTube Premium车票，还没到期的用户
  isTester(is_tester: boolean) {
    const body = { is_tester };
    const url = this.buildurl('/notice/user/is_tester');
    return this.http.put(url, body);
  }

  closeChangeCommissionModal() {
    const url = this.buildurl('/promotion/user');
    return this.http.put(url, {});
  }

  getDingdingData() {
    const url = this.buildurl('/ding/access-url');
    return this.http.fget(url);
  }

  postDingdingData(user_jwt: any) {
    const body = { user_jwt };
    const url = this.buildurl('/ding/user/info');
    return this.http.post(url, body);
  }

  getKnowPasswordChange(know: boolean = true) {
    const url = this.buildurl('/self/know_password_change');
    const body = { know };
    return this.http.put(url, body);
  }
}
